
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/stores/[storeSlug]",
      function () {
        return require("private-next-pages/stores/[storeSlug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/stores/[storeSlug]"])
      });
    }
  